import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePCrmInvoiceCategorys, PCrmInvoiceCategory } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<PCrmInvoiceCategory>
      useData={usePCrmInvoiceCategorys}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
